// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 167) return "static/js/BingoGames.bdeecaddbfaee611f8d5.chunk.js";
	if (chunkId === 911) return "static/js/GameDetails.2d453efb71f6ba047de4.chunk.js";
	if (chunkId === 995) return "static/js/SearchCategory.313eb9f1f51f4d0fc4e5.chunk.js";
	if (chunkId === 905) return "static/js/SearchMoreResults.49f647e32d6dfac17966.chunk.js";
	if (chunkId === 97) return "static/js/Footer.abb8a860f36dffdb4a8b.chunk.js";
	if (chunkId === 597) return "static/js/SimplifiedHeader.ded46d38da1b0d07f564.chunk.js";
	if (chunkId === 562) return "static/js/SearchHeader.31a400f5db619ff817a5.chunk.js";
	if (chunkId === 665) return "static/js/SearchHistory.e79830b4e57a3a5812bd.chunk.js";
	if (chunkId === 98) return "static/js/ErrorPage.e6c64910e6774d885e32.chunk.js";
	if (chunkId === 620) return "static/js/GameModal.77feff447a3f92e896ea.chunk.js";
	if (chunkId === 956) return "static/js/Copy.95e143ab5dabf9ead2a2.chunk.js";
	if (chunkId === 408) return "static/js/ErrorContainer.c1ed3de6646dbafa7495.chunk.js";
	if (chunkId === 7) return "static/js/CookieBanner.b200eee4336c0d7b1f8f.chunk.js";
	if (chunkId === 449) return "static/js/Menu.5d9e5b9f2065e394d038.chunk.js";
	if (chunkId === 795) return "static/js/SearchDesktopWrapper.f7f5b7924a202ff516f5.chunk.js";
	if (chunkId === 764) return "static/js/SearchWrapper.3bfbee83540b1a3b4ace.chunk.js";
	if (chunkId === 942) return "static/js/Download.36d4cec02c568c3967c7.chunk.js";
	if (chunkId === 215) return "static/js/SearchSuggestions.b3810b6e6afac507d46b.chunk.js";
	if (chunkId === 887) return "static/js/Steps.ae5497e1a16b8b884032.chunk.js";
	if (chunkId === 216) return "static/js/BannerStandalone.9c929fdee5e6da0f7d07.chunk.js";
	if (chunkId === 955) return "static/js/ProvidersFilter.846e8cd45271413b44f5.chunk.js";
	if (chunkId === 736) return "static/js/GameBanner.e82e02f067047f7d40a1.chunk.js";
	if (chunkId === 706) return "static/js/GameDual.bdc26e34e858e2c13963.chunk.js";
	if (chunkId === 461) return "static/js/GameList.7e51e6618d1a58602737.chunk.js";
	if (chunkId === 495) return "static/js/Grid.cb48c4d1169ef882784e.chunk.js";
	if (chunkId === 644) return "static/js/ExtendedGrid.ee512cc0cf90ffdadb93.chunk.js";
	if (chunkId === 500) return "static/js/WidgetGrid.ed5d6559dca2a622c869.chunk.js";
	// return url for filenames based on template
	return undefined;
};